<template slot-scope="scope">
  <!-- 消息通知 表格 组件 -->
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#409eff ',
          textAlign: 'center',
          color: '#FFFFFF',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        @selection-change="handleSelectionChange"
        :row-key="getRowKeys"
        :row-style="{ height: '35px' }"
        ref="multipleTable"
      >
        <el-table-column
          :reserve-selection="true"
          type="selection"
          width="55"
          align="center"
        >
        </el-table-column>
        <el-table-column label="ID" align="center" show-overflow-tooltip width="200">
          <template slot-scope="scope">
            <span :style="scope.row.msgStatus == '1' ? 'color:#9D9E9E' : ''">{{
              scope.row.msgId
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="消息内容"
          align="left"
          header-align="center"
          class-name="col-msg-content"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span :style="scope.row.msgStatus == '1' ? 'color:#9D9E9E' : ''">{{
              scope.row.content
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="消息类型" align="center" width="100px">
          <template slot-scope="scope">
            <span :style="scope.row.msgStatus == '1' ? 'color:#9D9E9E' : ''">{{
              scope.row.typeName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" align="center" width="200px">
          <template slot-scope="scope">
            <span :style="scope.row.msgStatus == '1' ? 'color:#9D9E9E' : ''">{{
              $tool.turnTime(scope.row.sendTime)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center"  width="250px">
          <template slot-scope="scope">
            <div
              v-if="select == '5'"
              class="table-p"
              @click="handleRecover(scope.$index, scope.row)"
            >
              <i class="el-icon-refresh"></i>恢复
            </div>
            <div
              v-else
              class="table-p"
              @click="handleEdit(scope.$index, scope.row)"
            >
              <i class="el-icon-view"></i>查看
            </div>
            <div class="table-p table-p--delete" @click="handleDelete(scope.$index, scope.row)">
              <i class="el-icon-delete"></i>删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 查看消息弹窗 -->
      <Dialog
        :dialogVisible="dialogVisible"
        :dataObj="dataObj"
        @handleClose="handleClose"
      ></Dialog>
    </div>
  </div>
</template>

<script>
import {
  companyNoReadCount, //企业未读消息数量
} from "../../../../../assets/api/CenterNotiFication";
// 引入接口
import {
  getSysCompanyMsgById, //企业消息列表
  readCompanyMsg, // 消息已读
  trashCompanyMsg, //消息丢弃到回收站
  restoreCompanyMsg, //消息从回收站恢复
  delCompanyMsg, // 删除
} from "../../../../../assets/api/firm/firmCenter";
// 引入查看消息组件
import Dialog from "./dialog.vue";
export default {
  props: {
    // 接收父组件传递的参数
    tableData: {},
    select: {},
    RefreshModule: {},
  },
  components: {
    Dialog,
  },
  data() {
    return {
      expands: [], // 表格选中
      singleExpands: [], // 单个删除
      multipleSelection: [], //多选
      dialogVisible: false, // 查看弹窗
      dataObj: {}, // 调用查看接口获取的内容 传给展示弹窗
    };
  },
  watch: {
    // 监听
    select: {
      // 表格改变清空多选内容
      handler(newss, old) {
        this.$refs.multipleTable.clearSelection();
      },
      immediate: false,
    },
    // 监听
    RefreshModule: {
      // 表格改变清空多选内容
      handler(newss, old) {
        this.$refs.multipleTable.clearSelection();
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  methods: {
    getRowKeys(row) {
      // console.log(row)
      return row.msgId;
    },
    //开启 恢复弹窗
    handleRecover(index, row) {
      if (!this.$checkAction()) return
      this.$confirmWithScroll("确定要恢复这条消息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var data = {
          data: {
            msgIds: [row.msgId],
          },
        };
        restoreCompanyMsg(data).then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.$emit("Refresh");
          }
        });
      }).catch(() => {
        // 用户取消恢复
      });
    },
    // 查看消息弹窗关闭
    handleClose(val) {
      this.dialogVisible = false;
    },
    // 表格的 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$emit("handleSelectionChange", val);
    },
    // 点击删除
    handleDelete(index, row) {
      if (!this.$checkAction()) return
      const confirmText = this.select == "5" ? "确定要彻底删除这条消息吗？" : "确定要删除这条消息吗？";
      this.$confirmWithScroll(confirmText, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var data = {
          data: {
            msgIds: [row.msgId],
          },
        };
        // 判断操作的是回收站的数据还是其他列表的数据
        if (this.select == "5") {
          // 等于5是在回收站 删除时使用彻底删除接口
          delCompanyMsg(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功");
              this.$emit("Refresh");
            }
          });
        } else {
          // 其余情况使用将数据放入回收站接口
          trashCompanyMsg(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功");
              this.$emit("Refresh");
            }
          });
        }
      }).catch(() => {
        // 用户取消删除
      });
    },
    // 点击查看 开启查看消息弹窗
    handleEdit(index, row) {
      if (!this.$checkAction()) return
      console.log(row, "row");
      var data = {
        data: {
          msgId: row.msgId,
        },
      };
      // 调用 查看消息接口
      getSysCompanyMsgById(data).then((res) => {
        if (res.code == 0) {
          this.dataObj = res.data;
          this.dialogVisible = true;
          // 查看消息接口调用成功 打开查看的同时设置 已读状态 并调用消息已读状态变更 接口
          row.msgStatus = 1;
          readCompanyMsg(data).then((res) => {
            if (res.code == 0) {
              // 更新未读消息数量
              companyNoReadCount().then((res) => {
                if (res.code == 0) {
                  this.$store.commit("SET_MSG_NUM", res.data);
                }
              });
            }
          });
        }
      });
    },
    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-checkbox__inner {
  border: 1px solid #409eff ;
}
// 表格中操作栏按钮样式
.table-p {
  display: inline-block;
  width: 60px;
  height: 24px;
  border-radius: 5px;
  background-color: #3894ff;
  text-align: center;
  color: #ffffff;
  line-height: 24px;
  cursor: pointer;
  i {
    margin-right: 5px;
  }
  & + .table-p {
    margin-left: 10px;
  }
  &--delete {
    background-color: #f26161;
  }
}
/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
/deep/th:nth-child(6) {
  border-radius: 0px 10px 0px 0px !important;
}
// /deep/th:nth-last-child(1) {
//   border-radius: 0 10px 0 0 !important;
// }

/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
.device-list-tab {
  border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-table .warning-row td {
  background: #eeeeee !important;
}
/deep/.el-table td.col-msg-content,
/deep/.el-table td.col-msg-content > .cell {
  text-align: left !important;
}</style>
